import React from 'react'

export default ({ ...props }) => (
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M18.75 2.54314e-06C19.0885 2.54314e-06 19.3815 0.1237 19.6289 0.371097C19.8763 0.618493 20 0.911462 20 1.25V18.75C20 19.0886 19.8763 19.3815 19.6289 19.6289C19.3815 19.8763 19.0885 20 18.75 20H13.75V12.2266H16.25L16.6699 9.34569H13.75V7.08006C13.75 6.66339 13.8558 6.34438 14.0674 6.12303C14.279 5.90167 14.5898 5.79099 15 5.79099H16.875V3.19334C16.3151 3.10219 15.6315 3.05662 14.8242 3.05662C13.4831 3.05662 12.4593 3.39679 11.7529 4.07713C11.0465 4.75747 10.6933 5.68357 10.6933 6.85545V9.34569H8.19335V12.2266H10.6933V20H1.25C0.91146 20 0.618491 19.8763 0.371095 19.6289C0.123698 19.3815 0 19.0886 0 18.75V1.25C0 0.91146 0.123698 0.618491 0.371095 0.371094C0.618491 0.123698 0.91146 0 1.25 0L18.75 2.54314e-06Z'
      fill='white'
    />
  </svg>
)
